fragment ImageFragment on Image {
  id
  url
  width
  height
}
